import React from 'react';
import PortfolioRow from '../components/common/PortfolioRow';
import './PageStyles.css';

const PortfolioPage: React.FC = () => {
    const portfolioItems = [
        {
            title: 'Investronomer',
            description: 'Deep research tools and portfolio tracking for fundamental investors who think in decades, not days.',
            link: 'https://investronomer.com',
            image: '/assets/smart_portfolio_icon.svg',
            imageFit: 'contain' as const
        },
        {
            title: 'HSA Hub',
            description: 'Your simplified guide to Health Savings Accounts. Maximize your healthcare savings.',
            link: 'https://hsahub.us',
            image: '/assets/hsahub-logo.png',
            imageFit: 'contain' as const
        }
    ];

    return (
        <div className="page-container">
            <div className="container">
                <h1 className="page-title">Portfolio</h1>
                <div className="portfolio-list-container">
                    {portfolioItems.map((item, index) => (
                        <PortfolioRow
                            key={index}
                            title={item.title}
                            description={item.description}
                            link={item.link}
                            image={item.image}
                            imageFit={item.imageFit}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PortfolioPage;
